import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Avatar, Button, EmptyState, Icon, Modal, Skeleton, fmtNum, gradientOf } from "../components/ui";
import Comments from "../components/social/Comments";
import PostComposer from "../components/social/PostComposer";
import ReportModal from "../components/social/ReportModal";
import { normMedia } from "../components/social/PostCard";
import useMe from "../components/social/useMe";
import { useAsync } from "../hooks";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import { useI18n } from "../services/i18n";
import content from "../services/api-content";
import "../styles/content.css";

function Short({ s, meId, isSuper }) {
  const toast = useToast();
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(Number(s.likeCount) || 0);
  const [comments, setComments] = useState(false);
  const [report, setReport] = useState(false);
  const video = (s.media || []).map(normMedia).find((m) => m && m.type === "video");
  const image = (s.media || []).map(normMedia).find((m) => m && m.type === "image");
  const charId = (s.characterIds || [])[0];
  const ref = useRef(null);
  const like = async () => {
    try { const r = await content.posts.like(s.id); setLiked(r.liked); setLikes(r.likeCount ?? likes + (r.liked ? 1 : -1)); } catch (e) { toast(e.message, "error"); }
  };
  return (
    <section className="short" style={{ background: gradientOf(null, s.userName || s.id) }} aria-label={`คลิปของ ${s.userName || "ผู้ใช้"}`}>
      {video ? <video ref={ref} src={video.url} controls loop playsInline preload="metadata" /> : image ? <img className="cover" src={image.url} alt="" /> : <div className="short__emoji" aria-hidden="true">🎬</div>}
      <div className="short__shade" />
      <div className="short__info">
        <Link to={`/creator/${s.userId}`} className="row" style={{ color: "#fff", gap: 8 }}><Avatar name={s.userName} src={s.userPhoto} size={32} /><b>{s.userName || "ผู้ใช้"}</b></Link>
        {s.text ? <p className="clamp-2 mt-8" style={{ color: "#fff" }}>{s.text}</p> : null}
        {charId ? <Link to={`/c/${charId}`} className="chip chip--sm mt-8">คุยกับตัวละครนี้ →</Link> : null}
        {!video && !image ? <p style={{ fontSize: 12, opacity: 0.8, marginTop: 8 }}>ไม่มีไฟล์วิดีโอแนบมากับโพสต์นี้</p> : null}
      </div>
      <div className="short__side">
        <Button icon onClick={like} aria-label="ถูกใจ" aria-pressed={liked} style={liked ? { color: "var(--accent)" } : undefined}><Icon name="heart" filled={liked} /></Button>
        <span style={{ color: "#fff", fontSize: 12 }}>{fmtNum(likes)}</span>
        <Button icon onClick={() => setComments(true)} aria-label="ความคิดเห็น"><Icon name="chat" /></Button>
        <Button icon onClick={() => setReport(true)} aria-label="รายงาน"><Icon name="shield" /></Button>
      </div>
      <Modal open={comments} onClose={() => setComments(false)} title="ความคิดเห็น"><Comments targetType="post" targetId={s.id} ownerId={s.userId} meId={meId} isSuper={isSuper} /></Modal>
      <ReportModal open={report} onClose={() => setReport(false)} targetType="post" targetId={s.id} title="รายงานคลิป" />
    </section>
  );
}

export default function Shorts() {
  const { t } = useI18n();
  const { isSuperUser } = useAuth();
  const me = useMe();
  const [add, setAdd] = useState(false);
  const { data, loading, error, reload } = useAsync(() => content.posts.list({ type: "short", limit: 20 }), []);
  const bar = (
    <div style={{ position: "absolute", top: 10, left: 10, right: 10, zIndex: 5, display: "flex", justifyContent: "space-between", pointerEvents: "none" }}>
      <b style={{ color: "#fff", textShadow: "0 1px 4px #000", pointerEvents: "auto" }}>{t("คลิปสั้น")}</b>
      <Button size="sm" variant="primary" onClick={() => setAdd(true)} style={{ pointerEvents: "auto" }}>+ เพิ่มคลิป</Button>
    </div>
  );
  return (
    <div style={{ position: "relative" }}>
      {bar}
      {error ? <div style={{ padding: 24 }}><EmptyState icon="⚠️" title="โหลดคลิปไม่สำเร็จ" action={<Button onClick={reload}>ลองใหม่</Button>}><span className="error-text">{error}</span></EmptyState></div>
        : loading ? <div style={{ padding: 24 }}><Skeleton height={420} radius={24} /></div>
        : !data.items.length ? <EmptyState icon="🎬" title="ยังไม่มีคลิปสั้น" action={<Button variant="primary" onClick={() => setAdd(true)}>เพิ่มคลิปแรก</Button>}>แชร์โมเมนต์สนุก ๆ ด้วยลิงก์วิดีโอ</EmptyState>
        : <div className="shorts">{data.items.map((s) => <Short key={s.id} s={s} meId={me?.id} isSuper={isSuperUser} />)}</div>}
      <Modal open={add} onClose={() => setAdd(false)} title="เพิ่มคลิปสั้น"><PostComposer type="short" onPosted={() => { setAdd(false); reload(); }} /></Modal>
    </div>
  );
}
